import React, { useEffect, useState } from 'react';
import {
  fetchEntitlements,
  isAdFreeActive,
} from '../../services/paymentEntitlementService';

/**
 * OW-172 / OW-176 — AdSense only on approved public surfaces.
 * Suppressed when ad_free_monthly is active (fail-open if entitlements fail).
 */
type AdSenseSurface = 'landing' | 'legal_public' | 'about';

interface AdSenseSlotProps {
  surface: AdSenseSurface;
  className?: string;
}

const SLOT_IDS: Record<AdSenseSurface, string | undefined> = {
  landing: process.env.REACT_APP_ADSENSE_SLOT_LANDING,
  legal_public: process.env.REACT_APP_ADSENSE_SLOT_LEGAL,
  about: process.env.REACT_APP_ADSENSE_SLOT_ABOUT,
};

export const AdSenseSlot: React.FC<AdSenseSlotProps> = ({
  surface,
  className,
}) => {
  const [suppressed, setSuppressed] = useState(false);
  const pubId = process.env.REACT_APP_ADSENSE_PUB_ID;
  const slotId = SLOT_IDS[surface];

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const entitlements = await fetchEntitlements();
      if (!cancelled) {
        setSuppressed(isAdFreeActive(entitlements));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (suppressed || !pubId || !slotId) return;
    try {
      // @ts-expect-error adsbygoogle global
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // ignore
    }
  }, [suppressed, pubId, slotId]);

  if (suppressed || !pubId || !slotId) {
    return null;
  }

  return (
    <div className={className ?? 'my-6 flex justify-center'} data-ad-surface={surface}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={pubId}
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdSenseSlot;
